// The ONE reader of `prefers-reduced-motion` in TypeScript (#6771, epic #6552). Owner ruling
// (ivndev001, 2026-10-20): reduced motion is a STILL FRAME. The stylesheet's half is the
// `reduce-motion` mixin (`styles/_mixins.scss`); this is the half a stylesheet cannot answer,
// such as "should the ghost fly back?" or "should the Live canvases animate?".
//
// Its readers: the move drag (`components/machine-card/DragLayer.tsx`, `MoveToMenu.tsx`), the
// transfer motion a move draws once accepted (`./transfer-motion.ts`, #6772),
// the Fleet Live frame loop (`./fleet-live-loop.ts`, which also follows the query's changes
// through `reducedMotionQuery`) and the roles section's scroll (`components/FleetRoles.tsx`).
// `reduced-motion.test.ts` refuses the query string in any other TS file.
//
// Injected: a test hands its own matcher; a browser without `matchMedia` (and the test DOM)
// reads motion as allowed.

/** The media query, spelled once. */
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/** `window.matchMedia`'s shape, injectable. */
export type MotionMatcher = (query: string) => MediaQueryList | null;

/** The browser's matcher, read at call time so a test's stub applies. */
export const browserMotionMatcher: MotionMatcher = (query) =>
  typeof globalThis.matchMedia === 'function' ? globalThis.matchMedia(query) : null;

/** The live query, for a reader that follows its changes; null without `matchMedia`. */
export function reducedMotionQuery(
  match: MotionMatcher = browserMotionMatcher,
): MediaQueryList | null {
  return match(REDUCED_MOTION_QUERY);
}

/** Whether the person asked for reduced motion, now. */
export function prefersReducedMotion(match: MotionMatcher = browserMotionMatcher): boolean {
  return reducedMotionQuery(match)?.matches ?? false;
}
